import { StoreInterface } from "../../models";

export const getSelectedUsers = (store: StoreInterface) =>
  store.userManagement.selectedUsers

export const getSelectedTeam = (store: StoreInterface) =>
  store.userManagement.selectedTeam

export const getUsersEmails = (state: StoreInterface) =>state?.userManagement.emails
